import React from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useIsWebCouponsEnabled} from '../useIsWebCouponsEnabled';
import {lazy} from '@aboutyou/lazy-imports';
import {useBasketCount} from '@aboutyou/user';

const ActivateWebCouponInOutdatedBasketLazy = lazy(() =>
  import('./ActivateWebCouponInOutdatedBasket.eager').then(mod => ({
    default: mod.ActivateWebCouponInOutdatedBasket,
  })),
);

export const ActivateWebCouponInOutdatedBasket = () => {
  const {isAuthenticated} = useIsAuthenticated();
  const isWebCouponsEnabled = useIsWebCouponsEnabled();
  const noItemsInBasket = useBasketCount() === 0;

  if (!isWebCouponsEnabled || !isAuthenticated || noItemsInBasket) {
    return null;
  }

  return <ActivateWebCouponInOutdatedBasketLazy />;
};
